import { createApp } from '../_snowpack/pkg/vue.js';
import App from './App.vue.js';
import BvcSlider from './BvcSlider.vue.js';

// Vuetify
import '../_snowpack/pkg/vuetify/styles.css';
import { createVuetify } from '../_snowpack/pkg/vuetify.js';
import * as components from '../_snowpack/pkg/vuetify/components.js';
import * as directives from '../_snowpack/pkg/vuetify/directives.js';
import ApexChart from "../_snowpack/pkg/vue3-apexcharts.js";

const vuetify = createVuetify({
    theme: {
        defaultTheme: 'light',
    },
    components: {
        ...components,
        ApexChart,
        BvcSlider,
    },
    directives,
});

createApp(App)
    .use(vuetify)
    .use(ApexChart)
    .mount('#root');
